import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#050505] text-white pt-24 pb-10 px-6 md:px-12">
    <div className="grid md:grid-cols-3 gap-12 border-b border-white/10 pb-16">
      <div>
        <p className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">Brand</p>
        <p className="font-serif italic text-lg text-white/80 leading-relaxed max-w-xs">
          PAEON — peony, in Greek. Premium heavyweight streetwear, designed for rooftops and museums alike.
        </p>
      </div>
      <div>
        <p className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">Navigate</p>
        <div className="flex flex-col gap-3 text-xs tracking-[0.2em] uppercase">
          <Link to="/shop" data-testid="footer-shop-link" className="hover:opacity-50 transition-opacity w-fit">Shop</Link>
          <Link to="/" data-testid="footer-home-link" className="hover:opacity-50 transition-opacity w-fit">Home</Link>
        </div>
      </div>
      <div>
        <p className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">Cities</p>
        <p className="text-xs tracking-[0.2em] uppercase text-white/70 leading-loose">
          Los Angeles · Hollywood<br />San Diego · San Francisco<br />Worldwide
        </p>
      </div>
    </div>
    <img
      src="/brand/logo-crest-white.png"
      alt="PAEON peony and laurel crest"
      data-testid="footer-crest"
      className="mx-auto w-28 md:w-36 pt-16 select-none"
    />
    <p className="font-serif text-[18vw] md:text-[14vw] leading-none tracking-tight text-center pt-6 select-none text-white/95">
      PAEON
    </p>
    <div className="flex justify-between text-[10px] tracking-[0.25em] uppercase text-white/30 pt-6">
      <span>© 2026 PAEON</span>
      <span>ΠΑΙΩΝΙΑ</span>
    </div>
  </footer>
);
